import { Card, CardBody, Col } from "reactstrap";
import SweetAlert from "sweetalert2";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Btn } from "../../../../AbstractElements";
import { DangerAlerts, DangerMode } from "../../../../Constant";
import { DANGER_MESSAGES } from "../../../../Data/Bonus Ui/SweetAlert";

const DangerAlert = () => {
  const displayAlert = () => {
    SweetAlert.fire({ icon: "error", title: "It's danger", text: "Something went wrong!",confirmButtonColor:"#33BFBF" });
  };
  return (
    <Col xxl="3" lg="4" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={DangerAlerts} span={DANGER_MESSAGES} />
        <CardBody className="btn-showcase">
          <Btn color="secondary" className="sweet-1" type="button" onClick={displayAlert}>
            {DangerMode}
          </Btn>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DangerAlert;
